import { initializeApp } from "firebase/app";

const env = (name) => (process.env[name] || "").trim();

const firebaseConfig = {
  apiKey: env("REACT_APP_FIREBASE_API_KEY"),
  authDomain: env("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: env("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: env("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: env("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: env("REACT_APP_FIREBASE_APP_ID"),
  measurementId: env("REACT_APP_FIREBASE_MEASUREMENT_ID"),
};

export const firebasePublicConfig = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
};

const requiredFirebaseConfig = {
  apiKey: firebaseConfig.apiKey,
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
};

const missingConfig = Object.entries(requiredFirebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingConfig.length) {
  throw new Error(
    `Missing Firebase config in environment: ${missingConfig.join(", ")}. ` +
    "Add them in .env and restart the dev server (npm start)."
  );
}

const optionalConfigKeys = ["storageBucket", "messagingSenderId", "appId", "measurementId"];
const cleanFirebaseConfig = Object.fromEntries(
  Object.entries(firebaseConfig).filter(([key, value]) => {
    if (["apiKey", "authDomain", "projectId"].includes(key)) return true;
    if (!optionalConfigKeys.includes(key)) return true;
    return Boolean(value);
  })
);

export const app = initializeApp(cleanFirebaseConfig);